import React from 'react';
import { Card, Select, Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import { history } from '../../../redux/store';

const { Option } = Select;

interface Props {
  bundle: {
    id: number;
    points: number;
    thumb: string;
    name: string;
    price: number;
  };
  my?: boolean;
}

const Bundle = (props: Props) => {
  const { t } = useTranslation('genericScreen');
  const bundle = props.bundle;
  const my = props.my;

  return (
    <Badge.Ribbon text={bundle.points + ' ' + t('points')} color="purple">
      <Card
        hoverable
        onClick={() => {
          history.push('/bundles/' + bundle.id);
        }}
        className="dog-card"
        cover={
          <div
            className="trick-pic"
            style={{
              minWidth: 140,
              minHeight: 170,
              backgroundImage: `url(${bundle.thumb})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}
          />
        }
      >
        <div className="title">{bundle.name}</div>
        {!my && (
          <div className="price">
            {t('gbp')} {bundle.price}
          </div>
        )}
      </Card>
    </Badge.Ribbon>
  );
};

export default Bundle;
